import React from 'react';
import ShippingMethodForProducts from '../ShippingMethodsForProducts';
import styles from './DeliveryMethodCard.module.scss';
import { DeliveryMethodCardProps } from './types';

const DeliveryMethodCard = ({
  selectedShippingMethod,
  shippingMethod,
  onSelectShippingMethod,
  slaMessage,
}: DeliveryMethodCardProps) => {
  const { key, groups } = shippingMethod;

  return groups.map(({ id, products, shippingMethods }, index) => (
    <div
      role="region"
      aria-label={`delivery-method-key-${key}`}
      className={styles.container}
      key={`delivery-method-key-${key}-${id}`}
    >
      <div className={styles.title} />
      <div className={styles['shipping-methods-wrapper']}>
        <ShippingMethodForProducts
          groupId={id}
          parentKey={key ?? ''}
          products={products}
          availableShippingMethods={shippingMethods}
          selectedShippingMethod={selectedShippingMethod?.groups?.[index]}
          onSelectShippingMethod={onSelectShippingMethod}
          slaMessage={slaMessage}
        />
      </div>
    </div>
  ));
};

export default DeliveryMethodCard;
